import { Signer } from 'aws-amplify';
import { API, Auth } from 'aws-amplify/';
import AWS from 'aws-sdk';
import { cognitoConfig } from '../../config/cognito';
import { environment } from '../../config/env';

async function getToken() {
  const user = await Auth.currentAuthenticatedUser();
  const userSession = user.signInUserSession;
  return userSession.idToken.jwtToken;
}

async function getHeaders(request) {
  const cred = {
    access_key: AWS.config.credentials.accessKeyId,
    secret_key: AWS.config.credentials.secretAccessKey,
    session_token: AWS.config.credentials.sessionToken,
  };
  const serviceInfo = {
    region: cognitoConfig.userPool.region,
    service: 'execute-api',
  };
  const signedParams = await Signer.sign(request, cred, serviceInfo);
  delete signedParams.headers['host'];
  return signedParams.headers;
}

export const put = async (urlName, path, body) => {
  const token = await getToken();
  const headers = await getHeaders({
    url: `${environment.baseUrl}${path}`,
    method: 'PUT',
    data: JSON.stringify(body),
  });
  return API.put(urlName, path, {
    body,
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json',
      ...headers,
    },
  });
};

export const post = async (urlName, path, body) => {
  const token = await getToken();
  const headers = await getHeaders({
    url: `${environment.baseUrl}${path}`,
    method: 'POST',
    data: JSON.stringify(body),
  });
  return API.post(urlName, path, {
    body,
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json',
      ...headers,
    },
  });
};

export const get = async (urlName, path) => {
  const token = await getToken();
  const headers = await getHeaders({
    url: `${environment.baseUrl}${path}`,
    method: 'GET',
  });
  return API.get(urlName, path, {
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json',
      ...headers,
    },
  });
};

export const del = async (urlName, path) => {
  const body = {};
  const token = await getToken();
  const headers = await getHeaders({
    url: `${environment.baseUrl}${path}`,
    method: 'DELETE',
    data: JSON.stringify(body),
  });
  return API.del(urlName, path, {
    body,
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json',
      ...headers,
    },
  });
};
